export default __webpack_public_path__ + "static/media/gallery_7.461c69c1.jpeg";